import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.HotelAurora;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "HotelAurora.Phaser.IntroductionScene.1",
            "HotelAurora.Phaser.IntroductionScene.2",
            "HotelAurora.Phaser.IntroductionScene.3",
            "HotelAurora.Phaser.IntroductionScene.4",
            "HotelAurora.Phaser.IntroductionScene.5",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/HotelAuroraGame/scenes/GameIntro.ts